import React, { useEffect, useState } from "react";
import { Backdrop, Box, Card, CircularProgress } from "@mui/material";
import {
  useGetAllCommissionsRulesQuery,
  useLazyGetAllCommissionsRulesQuery,
} from "../../redux/Slices/commissionsApi";
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import MDButton from "components/MDButton";
import AddIcon from "@mui/icons-material/Add";
import AddCommissionModal from "components/AddCommissionModel";
import DataTable from "examples/Tables/DataTable";
import CommissionsRuleTableData from "./CommissionRulesTableData";

const RulesSection = () => {
  const [getAllCommissionsWithStores, { isFetching }] = useLazyGetAllCommissionsRulesQuery();
  const { data: rules, isFetching: isFetchingRules } = useGetAllCommissionsRulesQuery();

  const [allRules, setAllRules] = useState([]);
  const [modalOpen, setModalOpen] = useState(false);
  const [currentCommission, setCurrentCommission] = useState(null);

  /* const [createRule, { isLoading: isCreating }] = useCreateCommissionRuleMutation();
  const [, dispatch] = useMaterialUIController (); */
  const handleEditClick = (commission) => {
    setCurrentCommission(commission);
    setModalOpen(true);
  };
  useEffect(() => {
    if (rules) {
      setAllRules(rules.data);
    }
  }, [rules]);
  const { columns, rows } = CommissionsRuleTableData(
    allRules,
    handleEditClick,
    getAllCommissionsWithStores
  );

  return (
    <>
      <Backdrop open={isFetchingRules} sx={{ zIndex: 2000, color: "#fff" }}>
        <CircularProgress color="inherit" />
      </Backdrop>

      <AddCommissionModal
        open={modalOpen}
        onClose={() => {
          setModalOpen(false);
          setCurrentCommission(null);
        }}
        initialData={currentCommission}
      />

      <MDBox pt={6} pb={3}>
        <Card>
          <MDBox
            mx={2}
            mt={-3}
            py={3}
            px={2}
            borderRadius="lg"
            display="flex"
            justifyContent="space-between"
            alignItems="center"
            sx={{
              background: "linear-gradient(90deg, #ca9937, #e0b15a)",
              boxShadow: 3,
            }}
          >
            <MDTypography variant="h6" color="white">
              قائمة العمولات
            </MDTypography>
            <MDButton
              variant="contained"
              color="white"
              startIcon={<AddIcon />}
              sx={{ color: "white" }}
              onClick={() => setModalOpen(true)}
            >
              إنشاء قاعدة
            </MDButton>
          </MDBox>
          <Box>
            <DataTable
              table={{ columns, rows }}
              isSorted={false}
              entriesPerPage={false}
              showTotalEntries={true}
              noEndBorder
              sx={{
                "& .MuiTable-root": { minWidth: 1000 },
                "& .MuiTableCell-root": {
                  py: 1.5,
                  borderBottom: (theme) => `1px solid ${theme.palette.divider}`,
                },
                "& .MuiTableHead-root": {
                  backgroundColor: (theme) => theme.palette.grey[100],
                },
              }}
            />
          </Box>
        </Card>
      </MDBox>
    </>
  );
};

export default RulesSection;
